import React, { useState, useEffect} from 'react'
import ReactTable from "react-table";
import {BotonRemovePequeño, BotonMenosPequeño, BotonAddPequeño} from '../Plantillas/Botones';
import {decimalAdjust} from "../../Global";

function MovimientoAlmacenDetalle(props) {

    const [rows, setRows] = useState([])

    useEffect(() => {
        setRows(props.data.sort((a, b) => (a.IdDetalleMovimientosAlmacen < b.IdDetalleMovimientosAlmacen) ? 1 : -1))
    }, [props.data])

    return (
        <ReactTable
            data={rows}
            disabled={false}
            columns={[
                {
                    Header: "Producto",
                    accessor: "NombreProductoConPresentacion",
                    minWidth: 215
                },
                {
                    Header: "Tipo Transacción",
                    accessor: "tipoTransaccion",
                    maxWidth: 140,
                },
                {
                    Header: "Precio con IGV/EXO/INA",
                    accessor: "Precio",
                    maxWidth: 110,
                    Cell: row => <div style={{textAlign: "right"}}>{row.value}</div>

                },
                {
                    Header: "Flete",
                    accessor: "Flete",
                    maxWidth: 100,
                    Cell: row => <div style={{textAlign: "right"}}>{row.value}</div>

                },
                {
                    Header: "Cantidad",
                    accessor: "Cantidad",
                    maxWidth: 100,
                    Cell: row => <div style={{textAlign: "right"}}>{row.value}</div>
                },
                {
                    Header: "Total",
                    accessor: "Total",
                    maxWidth: 100,
                    Cell: row => <div style={{textAlign: "right"}}>{decimalAdjust('floor', row.value, -2)}</div>
                },
                {
                    Header: "Acciones",
                    accessor: "IdDetalleOC",
                    Cell: (f) => {
                        return (
                            <div align='center'>
                                <BotonMenosPequeño
                                    className="ml-2"
                                    type="button"
                                    title="Disminuir en 1"
                                    onClick={
                                        () => props.handleAddQuantityItem(f.original, -1)
                                    }
                                />
                                <BotonAddPequeño
                                    type="button"
                                    title="Aumentar en 1"
                                    className="ml-2"
                                    onClick={
                                        () => props.handleAddQuantityItem(f.original, 1)
                                    }
                                />
                                <BotonRemovePequeño
                                    title="Eliminar"
                                    type='button'
                                    className="ml-2"
                                    onClick={
                                        () => props.handleEliminarItem(f.original)
                                    }
                                />
                            </div>
                        )
                    },
                },
            ]}

            defaultPageSize={20}
            showPagination={true}
            style={{
                height: "200px",
                width: "100%",
                fontSize: "13px"
            }}
            className="-striped -highlight"
        />
    )

}

export default MovimientoAlmacenDetalle
